module.exports = __webpack_public_path__ + "static/media/search-load.6e385eee.gif";